const KEY_DEMO_PROJECT = 'demo_project';
const KEY_SHOULD_BLOCK_ACCESS = 'sba';
const DEMO_PARAM = 'demoModalExample';

export { DEMO_PARAM, KEY_DEMO_PROJECT, KEY_SHOULD_BLOCK_ACCESS };

